import React from "react";
import { useTranslation } from "react-i18next";
import { RequestDeleteName } from "./RequestDeleteName";

export const DownloadOptions = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className="p-6 bg-gradient-to-r shadow-lg rounded-lg mx-auto mt-4">
      <div className="flex items-center mb-4">
        <h1 className="text-2xl font-bold text-blue-800">{t('documents')}</h1>
      </div>
      <div className="flex justify-between p-2">
        <div className="flex space-x-4">
          <a
            href="/Narrativa Inversión y Multinivel.docx"
            className="bg-blue-700 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded"
          >
            Narrativa Inversión y Multinivel.docx
          </a>
          <a
            href="/Denuncia Billions.docx"
            className="bg-blue-700 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded"
          >
            Denuncia Billions.docx
          </a>
          {user.is_xlsx_available === 1 &&
            <a
              href={`https://xlsx.ponzilover.com/${user.id}.xlsx`}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            >
              {user.id}.xlsx
            </a>
          }
        </div>
        {!user.hide_requested && <RequestDeleteName id={user.id} />}
      </div>
    </div>

  );
};
